var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.editable)?_c('button',{staticClass:"add-node",on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"fa fa-plus"})]):_c('div',{staticClass:"inactive-node"})}
var staticRenderFns = []

export { render, staticRenderFns }